import {
  applicationStatusOptions,
  inquiryStatusOptions,
  userStatusOptions,
} from "types/Status/StatusConstants";

export enum SortOrder {
  ASCENDING = "asc",
  DESCENDING = "desc",
}

export const limits = [5, 10, 20, 50];

export const limitOptions = limits.map((limit) => ({
  label: limit.toString(),
  value: limit.toString(),
}));

export const sortDateOptions = [
  { label: "Oldest", value: SortOrder.ASCENDING },
  { label: "Newest", value: SortOrder.DESCENDING },
];

export const sortNameOptions = [
  { label: "Name (Ascending)", value: SortOrder.ASCENDING },
  { label: "Name (Descending)", value: SortOrder.DESCENDING },
];

export const sortFeeOptions = [
  { label: "Fee: Low to High", value: SortOrder.ASCENDING },
  { label: "Fee: High to Low", value: SortOrder.DESCENDING },
];

export const sortUserOptions = [
  { label: "Name (A-Z)", value: "name-asc" },
  { label: "Name (Z-A)", value: "name-desc" },
  { label: "Last Login (Newest)", value: "lastLogin-newest" },
  { label: "Last Login (Oldest)", value: "lastLogin-oldest" },
  { label: "Status", value: "status" },
];

export const sortApplicationStatusOptions = [
  { label: "All", value: "ALL" },
  ...applicationStatusOptions.map((option) => ({
    label: option.label,
    value: option.value,
  })),
];

export const sortInquiryStatusOptions = [
  { label: "All", value: "ALL" },
  ...inquiryStatusOptions.map((option) => ({
    label: option.label,
    value: option.value,
  })),
];

export const sortUserStatusOptions = [
  { label: "All", value: "ALL" },
  ...userStatusOptions.map((option) => ({
    label: option.label,
    value: option.value,
  })),
];
